query Dashboard($dateFrom: DateTime!, $dateTo: DateTime!) {
  dashboard {
    videosCount
    videosDuration
    finishedStreamsCount
    finishedStreamDuration
    metrics(dateFrom: $dateFrom, dateTo: $dateTo) {
      views
      viewsTrend
      visitors
      visitorsTrend
      purchases
      purchasesTrend
      revenue
      revenueTrend
      revenueCurrency
      users
      usersTrend
    }
  }
}
